import { validateByCountryCode } from './validateByCountryCode';
import { validateIsCreditCard } from './validateIsCreditCard';

const validateCardNumber = async ({
  cardNumber,
  excludeCardCountryCodes,
}: {
  cardNumber: string;
  excludeCardCountryCodes: Array<{ code: string; message: string }>;
}) => {
  if (!excludeCardCountryCodes.length) {
    return null;
  }

  const isAllowedByCountryCodesErrorMessage = await validateByCountryCode({
    cardNumber,
    excludeCardCountryCodes,
  });
  const isCreditCardErrorMessage = validateIsCreditCard(cardNumber);

  return isAllowedByCountryCodesErrorMessage || isCreditCardErrorMessage || null;
};

export const asyncValidate = async (values, dispatch, props) => {
  const { cardNumber } = values;
  const { excludeCardCountryCodes = [] } = props;

  let errors = {};

  if (!values.id) {
    errors = {
      cardNumber: await validateCardNumber({ cardNumber, excludeCardCountryCodes }),
    };
  }

  const hasErrors = Object.values(errors).filter(Boolean).length;

  if (hasErrors) {
    throw errors;
  }

  return Promise.resolve();
};
